import { tokens } from "../../../theme";
import {
  Box,
  IconButton,
  Link,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { releaseStyles } from "../styles";
import { commitUrl, jiraTicketUrl, pullRequestUrl } from "./releaseViewHelpers";

// One commit, one fixed-height row. Repository is a column here: the payload nests it,
// but a hundred nested accordions cannot be scanned.
const CommitRow = ({ commit }) => {
  const theme = useTheme();
  const { releaseView } = releaseStyles(tokens(theme.paletteId));
  return (
    <Box sx={releaseView.row(commit.isDouble)}>
      <Tooltip title={commit.repoName} enterDelay={400}>
        <Typography sx={releaseView.repoCell}>{commit.repoName}</Typography>
      </Tooltip>

      <Typography sx={releaseView.tagCell}>{commit.tag}</Typography>

      {commit.jiraId ? (
        <Link
          href={jiraTicketUrl(commit.jiraId)}
          target="_blank"
          sx={releaseView.ticketLink}
        >
          {commit.jiraId}
        </Link>
      ) : (
        <Typography sx={releaseView.ticketEmpty}>&mdash;</Typography>
      )}

      <Box sx={releaseView.messageCell}>
        <Tooltip title={commit.message} enterDelay={400}>
          <Typography sx={releaseView.messageText}>{commit.message}</Typography>
        </Tooltip>
        {commit.hash ? (
          <Box className="commit-hash" sx={releaseView.hashBox}>
            <Link
              href={commitUrl(commit.repoName, commit.hash)}
              target="_blank"
              sx={releaseView.hashText}
            >
              {commit.hash}
            </Link>
            <Tooltip title="Copy commit hash">
              <IconButton
                size="small"
                sx={releaseView.copyButton}
                onClick={() => navigator.clipboard?.writeText(commit.hash)}
              >
                <ContentCopy sx={{ fontSize: 12 }} />
              </IconButton>
            </Tooltip>
          </Box>
        ) : null}
      </Box>

      <Box>
        {commit.flagKind === "double" ? (
          <Box component="span" sx={releaseView.flagChip(false)}>
            DOUBLE
          </Box>
        ) : commit.flagKind === "nodc" ? (
          <Box component="span" sx={releaseView.flagChip(true)}>
            NODC
          </Box>
        ) : null}
      </Box>

      {commit.pr ? (
        <Link
          href={pullRequestUrl(commit.repoName, commit.pr)}
          target="_blank"
          sx={releaseView.prCell}
        >
          #{commit.pr}
        </Link>
      ) : (
        <Box />
      )}
    </Box>
  );
};

export default CommitRow;
